export default "__VITE_ASSET__c97f90de__"